import i18n from '@/js/i18n';

const minPrenomNomLength = 2;
const maxPrenomNomLength = 25;

const minPwdLength = 8;
const maxPwdLength = 25;

export const maxNumeroCivicLength = 10;
export const minRueLength = 2;
// Il faut limiter la longueur du champ Rue à 40 pour éviter des éventuels pbs lors de la soumission à Paysafe
// Spécifications : TTP13212 (https://testtrackweb.loto-quebec.com/ttweb/index.html#default/18/issues/13279/)
const maxRueLength = 38; // + 2 car. dans la regex

const nomRegex =
  "^[a-zA-Z‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1}([a-zA-Z‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü-]||\\s(?!\\s)){0,23}[a-zA-Z‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1}$";

const rules = {
  // Règles générales
  // TODO: À déplacer hors compte
  heure: [
    {
      regex: new RegExp('^([0-1][0-9]|[2][0-3]):([0-5][0-9])$'),
      text: '',
      messageErreur: i18n.t('validations.messages.heureInvalide'),
    },
  ],
  alphaNumerique: [
    {
      regex:
        "^[a-zA-Z0-9‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1}([a-zA-Z0-9‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü-]|\\s(?!\\s)){0,23}[a-zA-Z0-9‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1}$",
      text: '',
      messageErreur: i18n.t('compte.alphaNumerique.erreurMessage'),
    },
  ],
  alphaNumeriqueSansEspace: [
    {
      regex: "^[a-zA-Z0-9‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1,25}$",
      text: '',
      messageErreur: i18n.t('compte.alphaNumerique.erreurMessage'),
    },
  ],

  // Règles spécifiques compte
  email: [
    {
      // Spécifications : https://lotoquebec.atlassian.net/browse/SWSPC-1663
      regex: new RegExp(
        "^(?=.{3,60}$)[A-Za-z0-9](?:[A-Za-z0-9!#‘'’*+\\/=?^_`{|}~-]|\\.(?!\\.)){0,53}[A-Za-z0-9!#‘'’*+\\/=?^_`{|}~-]@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,53}[A-Za-z0-9])?\\.)+[A-Za-z]{2,6}$"
      ),
      text: '',
      messageErreur: i18n.t('compte.email.erreurMessage'),
    },
  ],
  nom: [
    {
      regex: new RegExp(nomRegex),
      text: '',
      messageErreur: i18n.t('compte.nom.erreurMessage'),
    },
  ],
  prenom: [
    {
      regex: new RegExp(nomRegex),
      text: '',
      messageErreur: i18n.t('compte.prenom.erreurMessage'),
    },
  ],
  telephone: [
    {
      regex: new RegExp('^[0-9]{3}[ -]{1}[2-9]{1}[0-9]{2}-[0-9]{4}$'),
      text: '',
      messageErreur: i18n.t('compte.telephone.erreurMessage'),
    },
  ],
  // regex implémentée par Openbet décortiquée en sous-règles:
  // ^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d*.!@#\/$%?&*()\-_+=<>.,':;"]{8,25}$
  // 8 à 25
  // un chiffre obligatoire
  // une maj obligatoire
  // une min obligatoire
  // AUTRES CARACTÈRES optionnels: !@#/$%?&*()-_+=<>.,':;
  motDePasse: [
    {
      regex: new RegExp(`^(?=.{${minPwdLength},${maxPwdLength}}$)`),
      text: i18n.t('compte.mdp.libelleNbrCaractereValidation', {
        minPwdLength,
        maxPwdLength,
      }),
      messageErreur: i18n.t('compte.mdp.libelleNbrCaractereValidation', {
        minPwdLength,
        maxPwdLength,
      }),
    },
    {
      regex: /[a-z]+/,
      text: i18n.t('compte.mdp.libelleMinusculeValidation'),
      messageErreur: i18n.t('compte.mdp.libelleMinusculeValidation'),
    },
    {
      regex: /[A-Z]+/,
      text: i18n.t('compte.mdp.libelleMajusculeValidation'),
      messageErreur: i18n.t('compte.mdp.libelleMajusculeValidation'),
    },
    {
      regex: /\d+/,
      text: i18n.t('compte.mdp.libelleChiffreValidation'),
      messageErreur: i18n.t('compte.mdp.libelleChiffreValidation'),
    },
  ],
  mdpCaracteresSpeciaux: [
    {
      regex: /^([a-zA-Z]|[\d+]|[\x2F]|[-_!@#?*()+=.,:;'"‘’”“])*$/,
      text: i18n.t('compte.mdp.libelleUnCaractereInvalide'),
      messageErreur: i18n.t('compte.mdp.erreurCaractereInvalide'),
    },
    {
      regex: new RegExp(`^(?=.{${minPwdLength},${maxPwdLength}}$)`),
      text: i18n.t('compte.mdp.libelleNbrCaractereValidation', {
        minPwdLength,
        maxPwdLength,
      }),
      messageErreur: i18n.t('compte.mdp.libelleNbrCaractereValidation', {
        minPwdLength,
        maxPwdLength,
      }),
    },
    {
      regex: /[a-z]+/,
      text: i18n.t('compte.mdp.libelleMinusculeValidation'),
      messageErreur: i18n.t('compte.mdp.libelleMinusculeValidation'),
    },
    {
      regex: /[A-Z]+/,
      text: i18n.t('compte.mdp.libelleMajusculeValidation'),
      messageErreur: i18n.t('compte.mdp.libelleMajusculeValidation'),
    },
    {
      regex: /\d+/,
      text: i18n.t('compte.mdp.libelleChiffreValidation'),
      messageErreur: i18n.t('compte.mdp.libelleChiffreValidation'),
    },
  ],

  adresse: [
    {
      regex: new RegExp(
        `^[0-9](?:[0-9A-Za-z\\/-]|\\s){0,8}[0-9A-Za-z]?(?<![-\\s]),?\\s[a-zA-Z0-9ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü](?:[a-zA-Z0-9ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü‘'’.-]|\\s(?!\\s)){0,${maxRueLength}}[a-zA-Z0-9ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü.]$`
      ),
      text: '',
      messageErreur: i18n.t('compte.adresse.erreurMessage'),
    },
  ],
  appartement: [
    {
      regex: new RegExp(
        '^(?!0+$)[a-zA-Z0-9ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü](?:(?:[a-zA-Z0-9ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü#\\/-]|\\s(?!\\s)){0,6}[a-zA-Z0-9ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü])?$'
      ),
      text: '',
      messageErreur: i18n.t('compte.appartement.erreurMessage'),
    },
  ],
  ville: [
    {
      regex: new RegExp(
        "^[a-zA-Z‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1}([a-zA-Z‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü.-]|\\s){0,38}[a-zA-Z‘'’ÀÂâàÇçÉÈÊËéêèëÎÏîïÔôÙÛÜûùü]{1}$"
      ),
      text: '',
      messageErreur: i18n.t('compte.ville.erreurMessage'),
    },
  ],
  codePostal: [
    {
      regex: new RegExp('^[GHJ][0-9][ABCEGHJ-NPRSTV-Z][-\\s]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$', 'i'),
      text: '',
      messageErreur: i18n.t('compte.codePostal.erreurMessage'),
    },
  ],
  codePromo: [
    {
      regex: /[a-zA-Z0-9]+/,
      text: '',
      messageErreur: i18n.t('compte.codePromo.erreurMessage'),
    },
  ],
  limiteMaxDepotHebdo: [
    {
      regex: /\d+/,
      text: '',
      messageErreur: i18n.t('compte.limiteMaxDepotHebdo.erreurMessage'),
    },
  ],
  codeArgentWeb: [
    {
      regex: new RegExp(
        '([2-7a-fh-zA-FH-Z]{4}(-){1}[2-7a-fh-zA-FH-Z]{4}(-){1}[2-7a-fh-zA-FH-Z]{4}(-){1}[2-7a-fh-zA-FH-Z]{4}(-){1}[2-7a-fh-zA-FH-Z]{1})'
      ),
      text: '',
      messageErreur: i18n.t('compte.codeArgentWeb.erreurMessage'),
    },
  ],
};

const validateCompteCondition = (value, regex) => {
  const validation = value.match(regex);
  if (validation == null || value.match(regex)[0] == 'NaN') {
    return false;
  }
  return true;
};

export default {
  minPrenomNomLength,
  maxPrenomNomLength,
  minPwdLength,
  maxPwdLength,
  rules,
  validateCompteCondition,
};
